/** Параметры отряда и пула по умолчанию (BLUEPRINT 3.5, 3.6). */
export const SQUAD_DEFAULTS = {
  /** Минимум для запуска = max(ceil(capacity × ratio), activity.minPlay) */
  minToLaunchRatio: 0.75,
  /** Размер отряда для неосновных активностей и фолбэк */
  defaultCapacity: 8,
  /** Дедлайн гарантии набора: дней с открытия продаж */
  saleWindowDays: 14,
  /** Срок жизни приглашения запасного по ссылке, дней */
  reserveInviteTtlDays: 7,
  /** Не больше стольких активных заявок в пуле на пользователя */
  maxPoolApplications: 2,
  /** Границы размера для предложенных активностей */
  proposalSizeMin: 2,
  proposalSizeMax: 16,
  /** Сколько вариантов размера можно указать в предложении */
  proposalMaxSizeOptions: 3,
  /** Сборов в сезоне */
  gatheringsPerSeason: 6,
  /** RSVP можно менять до T-24h */
  rsvpLockHours: 24,
} as const;

export type SquadDefaults = typeof SQUAD_DEFAULTS;

/** Возрастные полосы для матчинга и ячеек пула. */
export const AGE_BANDS = [
  { band: 1, min: 18, max: 26 },
  { band: 2, min: 27, max: 32 },
  { band: 3, min: 33, max: 38 },
  { band: 4, min: 39, max: 45 },
  { band: 5, min: 46, max: 99 },
] as const;

export type AgeBand = (typeof AGE_BANDS)[number]['band'];

export const MIN_AGE = 18;
export const MAX_AGE = 80;
